import { Component, DestroyRef, Input, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatePickerModule } from '@progress/kendo-angular-dateinputs';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ControlOptions } from '../../interfaces/control-options.interface';
import { placeholderDateFormat } from 'src/app/shared/constants/date-time-placeholders';
import { userSettingsFeature } from 'src/app/store/features/user-settings/user-settings-feature';
import { Store } from '@ngrx/store';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DateFilterService } from 'src/app/shared/services/filter/date-filter-service';

/**
 * Represents a control that allows the user to select a date.
 */
@Component({
  selector: 'bizz-shared-date-picker-control',
  standalone: true,
  imports: [CommonModule, DatePickerModule, ReactiveFormsModule],
  templateUrl: './date-picker-control.component.html',
  styleUrls: ['./date-picker-control.component.scss']
})
export class SharedDatePickerControlComponent implements OnInit {
  
  @Input() public control: FormControl;
  @Input() public options: ControlOptions;

  protected dateFormat: string = placeholderDateFormat;

  public constructor(private store$: Store, private destroyRef: DestroyRef, private dateFilterService: DateFilterService) {
    
  }
  public ngOnInit(): void {
    this.store$.select(userSettingsFeature.selectDateFormatTypeString).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: value => {
        this.dateFormat = this.dateFilterService.convertDateMomentFormat(value) ?? this.dateFormat;
      }
    });
  }

}
export interface DatePickerOptions extends ControlOptions {

}